/**
 * Injects MagicFX pill styles into Selecty selector-root shadow trees
 * used by the country-selector block.
 */

const STYLE_FLAG = 'data-country-selector-styled';

const PILL_STYLES = `
  .sel-disclosure-btn {
    position: relative !important;
    width: 100% !important;
    min-width: 220px !important;
    max-width: none !important;
    border-radius: 100px !important;
    border: 1px solid #ebebeb !important;
    background: #ffffff !important;
    padding: 10px 18px !important;
    gap: 10px !important;
    box-shadow: none !important;
    outline: none !important;
    text-decoration: none !important;
    z-index: 2 !important;
    justify-content: space-between !important;
  }

  .sel-disclosure-btn:focus,
  .sel-disclosure-btn:focus-visible,
  .sel-disclosure-btn[aria-expanded="true"],
  .sel-disclosure-btn:active {
    border: 1px solid #ebebeb !important;
    border-bottom: 1px solid #ebebeb !important;
    outline: none !important;
    box-shadow: none !important;
    text-decoration: none !important;
  }

  .sel-disclosure-btn::after,
  .sel-disclosure-btn .sel-underline,
  .sel-disclosure-btn .sel-focus-bar,
  .sel-disclosure-btn [class*="underline"],
  .sel-disclosure-btn [class*="focus"] {
    display: none !important;
    content: none !important;
    border: 0 !important;
    box-shadow: none !important;
    background: transparent !important;
    height: 0 !important;
  }

  .sel-title {
    font-family: var(--font-body--family, inherit) !important;
    font-size: var(--font-size--xs, 0.8125rem) !important;
    font-weight: var(--font-weight-normal, 400) !important;
    line-height: 1.4 !important;
    color: #000000 !important;
    white-space: nowrap !important;
    overflow: visible !important;
    text-overflow: clip !important;
  }

  .sel-pointer-wrapper {
    background: transparent !important;
    width: auto !important;
    height: auto !important;
    flex-shrink: 0 !important;
  }

  .sel-pointerContainer {
    transform: rotate(180deg) scale(1.5) !important;
  }

  .sel-arrow {
    fill: #000000 !important;
  }

  /* Remove closed-state underline without breaking open behaviour */
  .sel-itemsContainer,
  .sel-itemsList-static,
  .sel-view-names.sel-itemsContainer {
    border: 0 !important;
    border-top: 0 !important;
    border-bottom: 0 !important;
    box-shadow: none !important;
    outline: none !important;
    background: transparent !important;
  }

  .sel-itemsList-static {
    margin: 0 !important;
    padding: 0 !important;
    min-height: 0 !important;
    overflow: hidden !important;
  }

  [role="listbox"],
  .sel-list,
  .sel-popover,
  .sel-menu {
    border-radius: 16px !important;
    border: 1px solid #ebebeb !important;
    background: #ffffff !important;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08) !important;
    overflow: hidden !important;
    min-width: 100% !important;
  }

  [role="option"] {
    font-family: var(--font-body--family, inherit) !important;
    font-size: var(--font-size--xs, 0.8125rem) !important;
    font-weight: var(--font-weight-normal, 400) !important;
    color: #000000 !important;
    padding: 10px 14px !important;
  }

  [role="option"]:hover,
  [role="option"][aria-selected="true"],
  [role="option"][data-highlighted="true"] {
    background: #f4f4f4 !important;
  }
`;

/**
 * @param {ShadowRoot} shadowRoot
 */
function injectStyles(shadowRoot) {
  if (shadowRoot.host?.hasAttribute(STYLE_FLAG)) return;

  const style = document.createElement('style');
  style.textContent = PILL_STYLES;
  shadowRoot.appendChild(style);
  shadowRoot.host?.setAttribute(STYLE_FLAG, '');
}

/**
 * @param {Element} selectorRoot
 */
function styleSelectorRoot(selectorRoot) {
  if (!(selectorRoot instanceof HTMLElement)) return;

  if (selectorRoot.shadowRoot) {
    injectStyles(selectorRoot.shadowRoot);
    return;
  }

  let attempts = 0;
  const interval = setInterval(() => {
    attempts += 1;
    if (selectorRoot.shadowRoot) {
      injectStyles(selectorRoot.shadowRoot);
      clearInterval(interval);
    } else if (attempts > 40) {
      clearInterval(interval);
    }
  }, 250);
}

function styleAllCountrySelectors() {
  document.querySelectorAll('.country-selector selector-root').forEach(styleSelectorRoot);
}

styleAllCountrySelectors();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', styleAllCountrySelectors);
}

document.addEventListener('shopify:section:load', styleAllCountrySelectors);
document.addEventListener('shopify:block:select', styleAllCountrySelectors);
